<template>
<div class="conduct">
    <mark-preview :content="content"></mark-preview>
</div>
</template>

<script type="text/javascript">
import MarkPreview from './MarkPreview'

export default {
    props: ['comp'],
    data() {
        let conduct = require('raw!smui-doc/README.md')
        return {
            content: conduct
        }
    },
    watch: {
        comp(value) {
            try {
                this.content = require(`raw!smui-doc/components/${value}.md`)
            }
            catch(ex){}
        }
    },
    components: {MarkPreview}
}

</script>

<style type="text/css" lang="less">
.conduct {
    position: relative;
    line-height: 2em;
}
</style>


// WEBPACK FOOTER //
// Doc.vue?0f50e637